import {createSlice} from '@reduxjs/toolkit'
import {fetchProductGroups} from './productRulesThunk'

const initialState = {
  productGroups: [],
  serviceIdRules: [],
  loading: false,
  error: null,
}

const productRulesSlice = createSlice({
  name: 'productRules',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      // PRODUCT GROUPS
      .addCase(fetchProductGroups.fulfilled, (state, action) => {
        state.loading = false
        state.productGroups = [...action.payload].sort((a, b) =>
          a.product_group.localeCompare(b.product_group),
        )
      })

      .addMatcher(
        action =>
          action.type.startsWith('productRules/') &&
          action.type.endsWith('/pending'),
        state => {
          state.loading = true
          state.error = null
        },
      )

      .addMatcher(
        action =>
          action.type.startsWith('productRules/') &&
          action.type.endsWith('/rejected'),
        (state, action) => {
          state.loading = false
          state.error = action.payload
        },
      )
  },
})

export const selectProductGroups = state => state.productRules.productGroups
export const selectLoading = state => state.productRules.loading
export const selectError = state => state.productRules.error
export const selectAddonCodeMap = state => {
  const groups = state.productRules.productGroups
  return groups.reduce((map, {product_group, plan_code}) => {
    if (!map[product_group]) map[product_group] = []
    map[product_group].push(plan_code)
    return map
  }, {})
}

export default productRulesSlice.reducer
